<!--
 * @Description: 线索公海池
 * @Author: mdb
 * @Date: 2022-07-06 11:24:43
 * @LastEditTime: 2022-10-12 09:48:43
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        rowKey="clueId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosFbuPublicClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="线索类型">
              <a-select
                v-model:value="queryForm.clueTypeList"
                :options="clueTypeEnumComputed"
                placeholder="请选择"
                allowClear
                mode="multiple"
                max-tag-count="responsive"
                show-arrow
              />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value.trim="queryForm.customerName" :maxlength="100" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_fbu"
                  paramCode="fbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="创建时间">
              <CosRangePicker v-model:startTime="queryForm.startCreateTime" v-model:endTime="queryForm.endCreateTime" />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_fbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item label="前客户负责人">
              <UserSelect v-model:value="queryForm.beforeFollower" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="线索ID">
              <a-input v-model:value="queryForm.clueId" :maxlength="500" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'fbu_public_clue_assign_btn'" type="primary" @click="handleAssignPerson()"
            >分配线索</a-button
          >
          <a-button v-permission="'fbu_public_clue_receive_btn'" @click="handleReceive()">领取线索</a-button>
          <ExportButton v-permission="'fbu_public_clue_export_btn'" appId="cos_fbu" taskType="202" :search="queryForm"
            >导出</ExportButton
          >
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_fbu" paramCode="fbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'fbu_public_clue_assign_btn'" type="link" @click="handleAssignPerson(record)"
              >分配线索</a-button
            >
            <a-button v-permission="'fbu_public_clue_receive_btn'" type="link" @click="handleReceive(record)"
              >领取线索</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleQueryChange('fetch')" />
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ClueAssign from '../components/ClueAssign.vue'
import { clueTypeEnum } from '../dataConfig'
import { genderEnum, linkRoleTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { infoData } from '@/api/gucangSales/followRuleSetting'
import { publicClueList, publicClueCollect, salesClueDetail } from '@/api/gucangSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuPublicClueParams, FbuPublicClueListItem } from '@/typings/api/clueManage'
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_follow_purpose: [], // 拜访目的
  fbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_purpose', 'fbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
const clueRuleList = ref<string[]>([])
const getFollowRuleInfo = async () => {
  const { data } = await infoData({ appId: 'cos_fbu', configType: 3 })
  clueRuleList.value = (data as any).CLUE_RULE_2.split(',')
}
onMounted(() => {
  getFollowRuleInfo()
  getByParamCodes()
})

// 获取详情联系人信息
const showMask = (record: FbuPublicClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId as string }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}

const tableRef = ref()
const queryForm = reactive<FbuPublicClueParams>({ contact: { type: 1 } })

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/fbu/salesClue/view',
    query: ['clueId', 'isPublicClue=1', `returnPath=${route.fullPath}`],
    fixed: 'left',
    width: 200
  },
  { title: '线索ID', dataIndex: 'clueId', width: 200 },
  { title: '来源渠道', dataIndex: 'channel' },
  { title: '线索类型', dataIndex: 'clueType', dicData: clueTypeEnum },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '前负责人', dataIndex: 'beforeFollowerName' },
  { title: '最新跟进情况', dataIndex: 'followDesc' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '性别', dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: '角色', dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: '联系时间', dataIndex: ['contactStartTime', 'contactEndTime'], cosType: 'timeRange' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190 },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190 },
  { title: '首次领取人', dataIndex: 'firstFollowerName' },
  { title: '最后一次领取人', dataIndex: 'lastFollowerName' },
  { title: '流转公海池时间', dataIndex: 'transferTime', width: 190 },
  { title: '备注', dataIndex: 'remark' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])
const getList = (queryForm: FbuPublicClueParams, callBack: (res: any) => void) => {
  publicClueList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<FbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: FbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的线索')
  const data = row ? [row] : toRaw(selectedData.value)
  clueAssignRef.value?.init(data)
}
// 领取线索
const handleReceive = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning('请选择需要领取的线索')
  }
  const clueIdList: any[] = []
  if (row) {
    clueIdList.push(row.clueId)
  } else {
    selectedData.value.forEach((item) => {
      clueIdList.push(item.clueId)
    })
  }
  AModal.confirm({
    title: '是否确认领取所选择的线索？',
    content: `领取后${clueRuleList.value[0]}个工作日内未写1条跟进记录,线索会自动退回到公海池`,
    okText: '领取',
    onOk() {
      publicClueCollect({ clueIdList }).then(() => {
        message.success('领取成功')
        handleQueryChange('fetch')
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuPublicClue' }
</script>

<style scoped></style>
